import React from 'react';
import Crossflow from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/software/components/ui-jsw-compass-crossflow/index.tsx';

export const CrossflowImage = (): React.JSX.Element => (
	<Crossflow alt="Jira Crossflow" width={457} height={285} />
);
